import React from "react";

const PageNotFound = () => {
  return (
    <div className="pageNotFound" style={styles}>
      404 PAGE NOT FOUND! <br />
      PLEASE NAVIGATE TO ANOTHER PAGE.
    </div>
  );
};

const styles = {
  textAlign: "center",
  fontSize: "22px",
  fontWeight: 700,
  color: "#373736",
  position: "relative",
  top: "150px",
};
export default PageNotFound;
